import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=065cfb3b"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicationForm.vue?vue&type=style&index=0&id=065cfb3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports